//@ts-nocheck
import { PhoneNumberField } from "@aws-amplify/ui-react";
import { useTheme } from "hooks/useSingleton";
import { getCountries, getCountryCallingCode, parsePhoneNumberWithError } from "libphonenumber-js";
import React, { ChangeEvent, useEffect, useState } from "react";
import Svg from "../../Svg/Svg";
import OccupiedField from "../OccupiedField/OccupiedField";
import styles from "./PhoneField.module.scss";
import { useErrorBoundary } from "react-error-boundary";
import { recordSentry } from "utils/recordSentry";
import { FieldWrapper } from "@factorearth/component-library";
/**
 * Text Field Type Component
 * @param {Object} color configuration data.
 * @param {FieldInstance} fieldInstance the field template data combined with the instance
 * @param {FieldTemplate} fieldTemplate the field template for the instance using this field type
 * @param {mixed} value the value of the field
 * @param {Function} handleChange the on change call back
 * @param {Function} onBlur the on blur callback
 * @param {Boolean} fromTable true if the field is inside a table for css stuff
 */
const PhoneField = (props) => {
	const { fieldInstance, fieldInstanceId, fieldTemplate, value, handleChange, onBlur, handleFocus, fromTable, username, authUsername } = props;
	const color = useTheme();
	const [hasError, setHasError] = useState<boolean>(false);
	const [error, setError] = useState<string>("");
	const [countryCode, setCountryCode] = useState<string>("US");
	const [newValue, setNewValue] = useState<string>("");
	const [countryCallingCodeMap, setCountryCallingCodeMap] = useState<Record<string, string>>();
	const { showBoundary } = useErrorBoundary();

	useEffect(() => {
		const newCountryCallingCodeMap = {};
		const countryCodes = getCountries();
		for (const countryCode of countryCodes) {
			newCountryCallingCodeMap[countryCode] = getCountryCallingCode(countryCode);
		}
		setCountryCallingCodeMap(countryCallingCodeMap);
		if (value.includes("+") && value.includes(" ")) {
			const countryCallingCode = value.substring(0, value.indexOf(" "));
			const phoneNumber = value.substring(value.indexOf(" ") + 1).replace(/\s/g, "");
			setCountryCode(countryCallingCode);
			setNewValue(phoneNumber);
		} else {
			setNewValue(value);
		}
	}, []);

	const handleBlur = (e: ChangeEvent<HTMLSelectElement>) => {
		if (!e.target.value.length) {
			setHasError(false);
			setError("");
		}
		if (hasError) {
			if (value.includes("+") && value.includes(" ")) {
				const countryCallingCode = value.substring(0, value.indexOf(" "));
				const phoneNumber = value.substring(value.indexOf(" ") + 1).replace(/\s/g, "");
				setCountryCode(countryCallingCode);
				setNewValue(phoneNumber);
			} else {
				setNewValue(e.target.value);
			}
			setHasError(false);
		}

		try {
			onBlur();
		} catch (error) {
			recordSentry({ error, msg: "PhoneField onBlur Failed" });
			showBoundary(error);
		}
	};

	const onChange = (e: ChangeEvent<HTMLInputElement>) => {
		const newValue = e.target.value;
		if (newValue !== undefined) {
			setNewValue(newValue);
		}

		handleChange(e);
	};

	return (
		<FieldWrapper
			colorPalette={color}
			label={!fromTable ? fieldTemplate.header : undefined}
			link={fieldInstance.altInstanceId ? <Svg icon="LINKED" /> : undefined}
			data-test={"Field-Header"}
			style={{ justifyContent: "space-between" }}>
			{username && username !== authUsername ? (
				<OccupiedField username={username} />
			) : (
				<PhoneNumberField
					style={{ height: "40px", backgroundColor: color.background.primary, borderRadius: "0", borderRight: "none" }}
					defaultDialCode={countryCode}
					dialCodeList={getCountries()}
					placeholder={fieldTemplate.placeholder || "3035678910"}
					onDialCodeChange={(e: ChangeEvent<HTMLSelectElement>) => setCountryCode(e.target.value)}
					onChange={(e: ChangeEvent<HTMLInputElement>) => onChange(e)}
					onFocus={handleFocus}
					onBlur={(e) => handleBlur(e)}
					hasError={hasError}
					// errorMessage={error}
					value={newValue}
					data-fieldtemplateid={fieldTemplate.id}
				/>
			)}
		</FieldWrapper>
	);
};

export default PhoneField;
